module.exports = __webpack_public_path__ + "img/69.c18d65bb.png";